import { useParams } from "@tanstack/react-router";

export interface SpaceRouteParams {
  lessonId?: string;
  sectionId?: string;
  spaceSlug: string;
}

export const useSpaceRouteParams = (): SpaceRouteParams =>
  useParams({ strict: false });
